import { mapToCanActivate, Routes } from '@angular/router';
import { WaitingPageComponent } from "./modules/shared/components/waiting/views/waiting-page/waiting-page.component";
import { LoggedInGuardService } from "./modules/authentication/guards/logged-in-guard.service";
import { environment } from "../environment";
import { GlobalRedirectGuard } from "./modules/shared/guards/global-redirect-guard.service";
import { MaintenanceComponent } from "./modules/shared/components/maintenance/maintenance.component";
import { ShortUrlRedirectComponent } from "./modules/shared/components/short-url-redirect/short-url-redirect.component";
import { AuthGuard } from './modules/authentication/guards/auth-guard.service';

export const routes: Routes = [
    {
        path: 'messagerie',
        canActivate: [GlobalRedirectGuard, ...mapToCanActivate([AuthGuard])],
        title: 'Messagerie',
        loadComponent: () =>
            import('./modules/messagerie/components/messagerie-shell/messagerie-shell.component').then(
                (m) => m.MessagerieShellComponent
            )
    },
    {
        path: '',
        runGuardsAndResolvers: 'always',
        canActivate: [GlobalRedirectGuard],
        title: environment.title,
        loadChildren: () => import('../app/modules/admin/admin-routing.module').then(m => m.AdminRoutingModule)
    },
    {
        path: 'auth',
        canActivate: [LoggedInGuardService, GlobalRedirectGuard],
        title: 'Connexion',
        loadChildren: () => import('../app/modules/authentication/authentication-routing.module').then(m => m.AuthenticationRoutingModule)
    },
    {
        path: 'erreur',
        title: 'Erreur',
        component: WaitingPageComponent
    },
    {
        path: 'maintenance',
        title: 'Maintenance',
        canActivate: [GlobalRedirectGuard],
        component: MaintenanceComponent
    },
    {
        path: 'short/:code',
        component: ShortUrlRedirectComponent,
        title: 'Redirection'
    },
    {
        path: 'visio-indisponible',
        title: 'Visio indisponible',
        loadComponent: () =>
            import('./modules/visio/views/visio-indisponible/visio-indisponible.component').then(
                (m) => m.VisioIndisponibleComponent
            )
    },
    {
        path: 'visio-presence',
        title: 'Confirmation de présence',
        loadComponent: () =>
            import('./modules/visio/views/visio-presence/visio-presence.component').then(
                (m) => m.VisioPresenceComponent
            )
    },
    {
        path: 'form/:uniqueId',
        loadComponent: () =>
            import('./modules/formulaires/views/formulaire-public/formulaire-public.component').then(
                (m) => m.FormulairePublicComponent
            ),
        title: 'Formulaire'
    },
    {
        path: 'transfert/:uuid',
        loadComponent: () =>
            import('./modules/transfert/views/transfert-page/transfert-page.component').then(
                (m) => m.TransfertPageComponent
            ),
        title: 'Transfert de fichiers'
    },
    {
        path: 'elearning-public/:token',
        title: 'Formation publique',
        loadComponent: () =>
            import('./modules/elearning/views/formation-public/formation-public.component').then(
                (m) => m.FormationPublicComponent
            )
    },
    {
        path: 'rendez-vous/:token',
        loadComponent: () =>
            import('./modules/rendez-vous/views/rendez-vous-public/rendez-vous-public.component').then(
                (m) => m.RendezVousPublicComponent
            ),
        title: 'Prise de rendez-vous'
    },
    {
        // Page publique « Nous contacter » des outils partagés à l'extérieur (?source=visio|formulaire|…).
        path: 'contact',
        loadComponent: () =>
            import('./modules/contact-commercial/views/contact-commercial/contact-commercial.component').then(
                (m) => m.ContactCommercialComponent
            ),
        title: 'Nous contacter'
    },
    {
      path: 'enveloppe/sign/:token',
        loadComponent: () => import('./modules/enveloppe/views/enveloppe-sign-public/enveloppe-sign-public.component').then(m => m.EnveloppeSignPublicComponent),
        title: 'Signature de document'
    },
    {
        path: 'admin',
        canActivate: [GlobalRedirectGuard],
        children: [
            {
                path: '**',
                canActivate: [GlobalRedirectGuard],
                component: WaitingPageComponent
            },
        ],
    },
];
